import { useEffect } from "react";

type SeoProps = { title: string; description: string };

export default function Seo({ title, description }: SeoProps) {
  useEffect(() => {
    document.title = `${title} | Navastha Infotech`;
    const tag = document.querySelector('meta[name="description"]');
    if (tag) tag.setAttribute("content", description);
  }, [title, description]);
  return null;
}
